import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui';
Vue.prototype.$message = Message;

Vue.use(Router)
const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}


const $router =  new Router({
  routes: [
    {
      path: '/',
      redirect: '/Login'
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('@/view/Login'),

    },
    {
      path: '/Home',
      name: 'Home',
      component: () => import('@/view/Home'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/Index',
      name: 'Index',
      component: () => import('@/view/Index'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/Resources',
      name: 'Resources',
      component: () => import('@/view/Resources'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/Course',
      name: 'Course',
      component: () => import('@/view/Course'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/CourseDis',
      name: 'CourseDis',
      component: () => import('@/view/CourseDis'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/PersonCenter',
      name: 'PersonCenter',
      component: () => import('@/view/PersonCenter'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/CourseStart',
      name: 'CourseStart',
      component: () => import('@/view/CourseStart'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/PasswordUpdate',
      name: 'PasswordUpdate',
      component: () => import('@/view/PasswordUpdate'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/InformationUpdate',
      name: 'InformationUpdate',
      component: () => import('@/view/InformationUpdate'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/Notice',
      name: 'Notice',
      component: () => import('@/view/Notice'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/Message',
      name: 'Message',
      component: () => import('@/view/Message'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/userNotice',
      name: 'userNotice',
      component: () => import('@/view/userNotice'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    },
    {
      path: '/SelectResources',
      name: 'SelectResources',
      component: () => import('@/view/SelectResources'),
      beforeEnter(to, from, next) {
        if(!sessionStorage.getItem('personId')) {
          Message({
            message: '请先进行登录',
            type: 'warning'
          })
          next({ name : 'Login'})
        } else {
          next()
        }
      }
    }
  ]
})
$router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if(isChunkLoadFailed){
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
      location.reload();
      // const targetPath = $router.history.pending.fullPath;
      // $router.replace(targetPath);
  }
  
});
export default $router;
